import { render, staticRenderFns } from "./PanelInputArea.vue?vue&type=template&id=e049a2fa&scoped=true&"
import script from "./PanelInputArea.vue?vue&type=script&lang=js&"
export * from "./PanelInputArea.vue?vue&type=script&lang=js&"
import style0 from "./PanelInputArea.vue?vue&type=style&index=0&id=e049a2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e049a2fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e049a2fa')) {
      api.createRecord('e049a2fa', component.options)
    } else {
      api.reload('e049a2fa', component.options)
    }
    module.hot.accept("./PanelInputArea.vue?vue&type=template&id=e049a2fa&scoped=true&", function () {
      api.rerender('e049a2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelInputArea.vue"
export default component.exports